import React, {Fragment} from 'react';

import {getSpoonerism, getNormingSpoonerism} from 'constants/tests.js';
import StopWatch from 'components/StopWatch';
import AdminTestPanel from 'components/AdminTestPanel';
import AdminReadyButton from 'components/AdminReadyButton';
import {updateStepData} from 'api';
import strings from 'strings';
import CountDown from 'components/CountDown';

class SpoonerismAdmin extends AdminTestPanel {
	constructor(props) {
		super(props, {
			// Spoonerism stops after six consecutive wrong or unanswered items.
			maxConsecutiveErrors: 6,
			stopOnConsecutiveErrors: true,
			enableHotkeys: false,
		});
		const {ageGroup} = this.props;
		this.state = {
			...this.state,
			key: 1,
			showOneCorrectNextButton: false,
			waitingForNeste: false,
			selectedTest:
				ageGroup === 6 || ageGroup === 7
					? getNormingSpoonerism
					: getSpoonerism,
		};
	}

	getTestName = () => {
		return strings.sp_testname;
	};

	shouldResetOnFreshAttempt = () => true;

	// Retakes rebuild the age-specific test selector and clear waiting/countdown UI.
	getFreshAttemptState = () => {
		const {ageGroup} = this.props;

		return {
			key: 1,
			showOneCorrectNextButton: false,
			waitingForNeste: false,
			selectedTest:
				ageGroup === 6 || ageGroup === 7
					? getNormingSpoonerism
					: getSpoonerism,
		};
	};

	updateTimeUsed = (timeUsed) => {
		let skipTime = this.state.skipTime;
		if (skipTime === timeUsed) {
			// Time ran out — disable buttons, hide countdown, show Neste button
			const newSkipTime = 30 + timeUsed;
			this.setState({
				showOneCorrectNextButton: false,
				timeElapsedLasAnsnwer: timeUsed,
				timeUsed: timeUsed,
				skipTime: newSkipTime,
				waitingForNeste: true,
			});
			// Tell testuser side that time is up so it can show a waiting indicator
			updateStepData({timeExpired: true});
		} else {
			this.setState({
				timeUsed: timeUsed,
				timeElapsedLasAnsnwer: timeUsed,
			});
		}
	};

	handleNeste = () => {
		// Clear the testuser indicator before advancing
		updateStepData({timeExpired: false});
		// Give the next item a fresh 30-second window from this moment
		const newSkipTime = this.state.timeElapsedLasAnsnwer + 30;
		this.setState({waitingForNeste: false, skipTime: newSkipTime}, () => {
			this.answerUnanswered();
			this.handleCountdownComplete();
		});
	};

	answer = (numberOfCorrect) => {
		if (numberOfCorrect === 1) {
			updateStepData({
				answered: true,
				correct: false,
				feedbackDone: false,
				numberOfCorrect,
			});
		}
		if (numberOfCorrect === 2) {
			updateStepData({
				answered: true,
				correct: true,
				feedbackDone: false,
				numberOfCorrect,
			});
		} else {
			updateStepData({
				answered: true,
				correct: false,
				feedbackDone: false,
				numberOfCorrect,
			});
		}
	};

	componentWillReceiveProps(newProps) {
		if (super.componentWillReceiveProps(newProps)) return;

		if (
			newProps.stepData.feedbackDone &&
			!this.props.stepData.feedbackDone &&
			newProps.stepData.answered
		) {
			this.answerCorrect();
		}
	}

	getTask = (currentStep) => {
		return this.state.selectedTest().getIntroSteps()[currentStep].task;
	};
	getjoinedCorrect = (currentStep) => {
		return this.state.selectedTest().getIntroSteps()[currentStep].correct.join(' - ');
	};

	handleCountdownComplete = () => {
		this.setState((prevState) => ({
			key: prevState.key < 18 ? prevState.key + 1 : 1,
			showOneCorrectNextButton: false,
		}));
	};

	renderIntro = () => {
		const {currentStep} = this.state;
		const {ageGroup, candidateReady} = this.props;
		const introSteps = 2;
		const isNormingActive = ageGroup === 6 || ageGroup === 7;

		return (
			<Fragment>
				{currentStep === 0 && (
					<Fragment>
						<p>
							{isNormingActive
								? strings.sp_admin6
								: strings.formatString(
										strings.sp_admin1,
										<i>{strings.sp_example1}</i>
									)}
						</p>
						<AdminReadyButton
							isPractiseTasks
							remoteIsReady={
								isNormingActive ? true : candidateReady
							}
							onClick={this.props.nextStep}
						/>
					</Fragment>
				)}
				{currentStep > 0 && currentStep < introSteps && (
					<Fragment>
						<p>{strings.practiceTask}</p>
						<p>
							{strings.formatString(
								strings.taskNum,
								this.getTask(currentStep)
							)}
						</p>
						<p>
							{strings.formatString(
								strings.expectedAnswer,
								this.getjoinedCorrect(currentStep)
							)}
						</p>
						<div className="lit-all-buttons-div">
							<button
								disabled={this.props.stepData.answered}
								onClick={(e) => {
									e.stopPropagation();
									this.answer(2);
								}}
							>
								{strings.sp_2correct}
							</button>
							<button
								disabled={this.props.stepData.answered}
								onClick={(e) => {
									e.stopPropagation();
									this.answer(1);
								}}
							>
								{strings.sp_1correct}
							</button>
							<button
								disabled={this.props.stepData.answered}
								onClick={(e) => {
									e.stopPropagation();
									this.answer(0);
								}}
							>
								{strings.sp_bothWrong}
							</button>
						</div>
					</Fragment>
				)}
				{currentStep === introSteps && (
					<Fragment>
						<p>
							{isNormingActive
								? strings.sp_admin4
								: strings.sp_admin2}
						</p>
						<p>
							{isNormingActive
								? strings.clickStartWhenReady
								: strings.clickStartWhenReady}
						</p>
						<AdminReadyButton
							remoteIsReady={
								isNormingActive ? true : candidateReady
							}
							onClick={this.props.nextStage}
						/>
					</Fragment>
				)}
			</Fragment>
		);
	};

	renderTest = () => {
		const {currentStep, showOneCorrectNextButton, waitingForNeste} =
			this.state;
		const timeExpired =
			this.state.timeElapsedLasAnsnwer + 30 === this.state.skipTime;

		const steps = this.state.selectedTest().getSteps();
		return (
			<div>
				<div className="lit-stop-watch-div">
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
				</div>
				<p>
					<br />
					Lytt til testkandidaten og hør om de sier riktig ord som det
					som står på skjermen.
					<br />
					{strings.buttonDescription}
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						steps.length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.taskNum,
						steps[currentStep].task
					)}
				</p>
				<p>
					{strings.formatString(
						strings.expectedAnswer,
						<b>{steps[currentStep].correct.join(' - ')}</b>
					)}
				</p>
				<div className="lit-all-buttons-div">
					<button
						className="lit-correct-button-div"
						disabled={timeExpired || waitingForNeste}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect(2);
							this.handleCountdownComplete();
						}}
					>
						{strings.sp_2correct}
					</button>
					{!showOneCorrectNextButton && (
						<button
							disabled={timeExpired || waitingForNeste}
							onClick={(e) => {
								this.setState({showOneCorrectNextButton: true});
							}}
						>
							{strings.sp_1correct}
						</button>
					)}
					{showOneCorrectNextButton && (
						<button
							disabled={timeExpired || waitingForNeste}
							style={{width: '115px'}}
							onClick={(e) => {
								e.stopPropagation();
								const skipTime =
									30 + this.state.timeElapsedLasAnsnwer;
								this.setState({skipTime});
								this.answerCorrect(1);
								this.handleCountdownComplete();
							}}
						>
							{strings.sp_1correct_move_next}
						</button>
					)}
					<button
						disabled={timeExpired || waitingForNeste}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerWrong();
							this.handleCountdownComplete();
						}}
					>
						{strings.sp_bothWrong}
					</button>
					<div className="lit-count-down-div">
						{!waitingForNeste && (
							<CountDown
								key={this.state.key}
								duration={30}
								onComplete={() => {}}
							/>
						)}
						{waitingForNeste && (
							<button
								className="lit-neste-button"
								onClick={this.handleNeste}
							>
								Neste
							</button>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderWaiting = () => {
		return (
			<div>
				<p>
					{strings.formatString(
						strings.testDone,
						strings.sp_testname
					)}
				</p>
				<Fragment>
					<button onClick={this.props.nextStage}>
						{strings.nextTest}
					</button>
				</Fragment>
			</div>
		);
	};
}

export default SpoonerismAdmin;
